import { createTheme } from '@mui/material/styles';

/**
 * Brand tokens derived from the takeKONTROL logo: a dark ink ground, a single
 * red accent and a neutral grey scale. Use `accent` for fills/rules and
 * `accentStrong` whenever the colour carries text on a light surface.
 */
export const brand = {
  ink: '#111827',
  inkDeep: '#0B1220',
  inkSoft: '#1F2937',

  accent: '#F0313F',
  accentStrong: '#C8202D',
  accentMuted: '#7F1D1D',

  page: '#F3F4F6',
  surface: '#FFFFFF',
  surfaceMuted: '#FAFBFC',
  surfaceSunken: '#F6F7F9',

  border: '#E5E7EB',
  borderSoft: '#EEF2F7',
  borderStrong: '#D1D5DB',

  textPrimary: '#111827',
  textSecondary: '#4B5563',
  textMuted: '#6B7280',
  textFaint: '#9CA3AF',

  onInkPrimary: '#FFFFFF',
  onInkMuted: '#D1D5DB',
  onInkFaint: '#9CA3AF',
} as const;

export const theme = createTheme({
  typography: {
    fontFamily: "'Libre Franklin', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    allVariants: {
      letterSpacing: 0,
    },
  },
  palette: {
    primary: {
      main: '#000f2c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c2d8ff',
      contrastText: '#ffffff',
    },
    background: {
      default: '#000611',
    },
  },
  // Add more customization here
});
